import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function DesignSection({ fields, setFields, form }) {
  const addField = () => {
    const nextIndex = fields.length + 1;
    setFields(prev => [
      ...prev,
      {
        id: nextIndex,
        name: `gallery_img_${nextIndex}`,
        label: `Gallery Image ${nextIndex}`,
        image: null,
        alt: '',
      },
    ]);
  };

  const updateFile = (index, file) => {
    setFields(prev => {
      const updated = [...prev];
      updated[index].image = file;
      return updated;
    });
    form.setFieldsValue({
      [fields[index].name]: file,
    });
  };

  const updateAlt = (index, alt) => {
    setFields(prev => {
      const updated = [...prev];
      updated[index].alt = alt;
      return updated;
    });
  };

  const removeField = index => {
    setFields(prev => prev.filter((_, i) => i !== index));

    // Remove values from the form
    const fieldName = fields[index]?.name;
    const altName = `alt_${fields[index]?.name}`;
    if (fieldName) {
      form.setFieldsValue({
        [fieldName]: undefined,
        [altName]: undefined,
      });
    }
  };

  return (
    <div className="product-design-section">
      <span className="label">Design Section</span>
      <Form.Item
        label="Heading"
        type="text"
        placeholder="Heading"
        name="design_section_heading"
        sm
        rules={[{ required: true, message: 'Enter Alt' }]}>
        <Field />
      </Form.Item>
      <Form.Item
        label="Description"
        type="textarea"
        placeholder="Description"
        name="design_section_description"
        sm
        rules={[{ required: true, message: 'Enter Alt' }]}>
        <Field />
      </Form.Item>
      <button className="add-more" type="button" onClick={addField}>
        Add more <i className="material-icons-outlined">add</i>
      </button>
      <Grid xs={1} lg={3} colGap={10} rowGap={10}>
        {fields?.map((field, index) => (
          <div className="upload-field-holder" key={field?.id}>
            <Form.Item
              name={field?.name}
              type="chooseFile"
              small
              value={field?.image}
              displayFile={field.image?.preview || field?.image || null}
              fileName={field?.image?.name}
              deleteClick={() => removeField(index)}
              onChange={image => updateFile(index, image)}
              rules={[{ required: index < 3, message: `Select ${field?.label}` }]}>
              <Field />
            </Form.Item>
            <Form.Item
              name={`alt_${field?.name}`}
              type="text"
              placeholder="Alt"
              value={field?.alt}
              onChange={e => {
                updateAlt(index, e.target.value);
              }}
              sm
              rules={[{ required: false, message: 'Enter Alt' }]}>
              <Field />
            </Form.Item>
          </div>
        ))}
      </Grid>
    </div>
  );
}

export default DesignSection;
